import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { SuspendButtonPc, SuspendButtonMobile } from '@tencent/docs-scenario-components-suspend-button';
import { Props as PcProps } from '@tencent/docs-scenario-components-suspend-button/pc/type';
import { Props as MobileProps } from '@tencent/docs-scenario-components-suspend-button/mobile/type';

import style from './follow-btn.less';

/**
 * pc 端拖拽动作通过监听 body mousemove 实现，而 ppt 品类中存在不少 iframe
 * DOM 事件机制决定了，当鼠标经过 iframe 时，body 将接收不到 MouseEvent
 * 因此需要有一层 wrapper 接收事件并冒泡到 body
 */
const SuspendButtonPcExtended: React.FC<PcProps> = (props) => {
    const [isDragging, setIsDragging] = useState(false);
    const onDragStart = useCallback(() => setIsDragging(true), [setIsDragging]);
    const onDragEnd = useCallback(() => setIsDragging(false), [setIsDragging]);

    return (
        <div className={style.draggableContainer} style={{ pointerEvents: isDragging ? 'all' : 'none' }}>
            <SuspendButtonPc onDragStart={onDragStart} onDragEnd={onDragEnd} {...props} />
        </div>
    );
};

let hasBtnShown = false;
type Props = PcProps & MobileProps & {
    visiable: boolean;
};

const FollowButton: React.FC<Props> = (props) => {
    if (props.visiable) hasBtnShown = true;

    if (!hasBtnShown) return null;

    const SuspendButton = browser.isMobile ? SuspendButtonMobile : SuspendButtonPcExtended;

    return ReactDOM.createPortal(
        <SuspendButton
            {...props}
            style={{
                display: props.visiable ? undefined : 'none',
                zIndex: 'var(--z-index-tips)' as any,
            }}
        />,
        document.body,
    );
};

export default FollowButton;
